import {
    AUTH_TOKEN_REQUEST,
    AUTH_TOKEN_SUCCESS,
    AUTH_TOKEN_FAIL,
    SSO_ME_SUCCESS,
    SSO_ME_FAIL,
    CLEAR_SSO_SESSION
} from "../actions";

const initialState = {
    fetching: false,
    error: "",
    apiKey: null,
    token: null,
    userAuthenticated: false,
    user: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case AUTH_TOKEN_REQUEST:
            return {
                ...state,
                error: "",
                fetching: true
            };
        case AUTH_TOKEN_SUCCESS:
            return {
                ...state,
                apiKey: action.apiKey,
                token: action.token
            };
        case SSO_ME_FAIL:
        case AUTH_TOKEN_FAIL:
            return {
                ...state,
                error: action.payload,
                userAuthenticated: false,
                fetching: false,
                token: null,
                apiKey: null
            };
        case SSO_ME_SUCCESS:
            return {
                ...state,
                error: "",
                fetching: false,
                userAuthenticated: true,
                user: action.payload
            };
        case CLEAR_SSO_SESSION:
            return {
                ...initialState
            };
        default:
            return state;
    }
};
